import Layout from '@layout/Index'

export const tekeOrder = [
  {
    path: '/teke-order',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import('./pages/TekeOrderTable.vue'),
        name: '全部问卷',
        meta: {
          title: '全部问卷',
        },
      },
      {
        path: 'audit-table',
        component: () => import('./pages/TekeOrderAuditTable.vue'),
        name: '待复审问卷',
        meta: {
          title: '待复审问卷',
        },
      },
      {
        path: 'detail/:id',
        component: () => import('./pages/TekeOrderDetail.vue'),
        name: '问卷详情',
        meta: {
          title: '问卷详情',
        },
      },
      {
        path: 'review/:id',
        component: () => import('./pages/TekeOrderDetail.vue'),
        name: '问卷审核',
        meta: {
          title: '问卷审核',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/teke-order/tekeOrder.route.js